import {MarkdownViewer} from '@primer/react/experimental'
import {graphql, useFragment} from 'react-relay'
import type {MarkdownElement_input$data, MarkdownElement_input$key} from './__generated__/MarkdownElement_input.graphql'
import type {GraphqlFragment} from '../types'
import {Suspense} from 'react'
import {FormElementLoading} from '../FormElementLoading'

export type MarkdownElementInternalProps = GraphqlFragment<MarkdownElement_input$data> & {
  type: 'markdown'
}

export const MarkdownElement = ({elementRef}: {elementRef: MarkdownElement_input$key}) => {
  const data = useFragment(
    graphql`
      fragment MarkdownElement_input on IssueFormElementMarkdown {
        contentHTML
      }
    `,
    elementRef,
  )

  return <MarkdownElementInternal {...data} type={'markdown'} />
}

export const MarkdownElementInternal = ({contentHTML}: MarkdownElementInternalProps) => {
  return (
    // The Suspense boundary is required since MarkdownViewer doesn't seem to be SSR-compatible
    <Suspense fallback={<FormElementLoading />}>
      <MarkdownViewer dangerousRenderedHTML={{__html: contentHTML}} />
    </Suspense>
  )
}

try{ MarkdownElement.displayName ||= 'MarkdownElement' } catch {}
try{ MarkdownElementInternal.displayName ||= 'MarkdownElementInternal' } catch {}